// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xs9I8M2hXCI3_LsrX4Vw {\n  max-width: 1200px;\n  height: 1315px;\n  background: #ffffff;\n  border: none !important;\n  margin: -250px auto 48px;\n  font-family: Poppins, sans-serif;\n  color: #333333;\n}\n@media only screen and (max-width: 1200px) {\n  .xs9I8M2hXCI3_LsrX4Vw {\n    width: 1200px;\n  }\n}\n.xs9I8M2hXCI3_LsrX4Vw .OdWGIfbvyTXJghrE8xnY {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingviewCandidateCard": "xs9I8M2hXCI3_LsrX4Vw",
	"viewCandidateLoader": "OdWGIfbvyTXJghrE8xnY"
};
export default ___CSS_LOADER_EXPORT___;
